import Decimal from "decimal.js";
(window as any).Decimal = Decimal;

// 数字转化为 16进制
export const toHex = (num: number | string) => {
  return num.toString(16);
};
// 生成数字列表根据 interval
export function generateNumbers(
  start: number,
  end: number = 0,
  interval = 50 / 1000 // 1 秒 多少个点
) {
  const numbers = [];
  let currentNumber = new Decimal(start);
  const endNumber = new Decimal(end);
  while (currentNumber >= endNumber) {
    // 保留小数点后3位
    numbers.push(currentNumber.toDecimalPlaces(3).toNumber());
    // 执行减法操作
    currentNumber = currentNumber.minus(interval);
  }
  return numbers;
}

// 生成随机数  min - max
export function getRandomNumberInRange(
  min: number,
  max: number,
  fixed = 2
): number {
  const num = Math.random() * (max - min) + min;
  return Number(num.toFixed(fixed));
}
export function toFixed(num: string | number, fixed = 2): number {
  if (!num) return 0;
  return new Decimal(num).toDecimalPlaces(fixed).toNumber();
}
